import { ROBOT_NETWORK_STATUSES } from 'utils/constants'
import { IRobotInfo } from 'utils/interfaces'
import { hasActiveTaskRuntimeState } from 'utils/taskRuntimeState'

/** Fleet / Assets list: online first, then diagnostics, emergency, active task, serial. */
export function sortRobotsForAssetsList(robots: IRobotInfo[]): IRobotInfo[] {
  return [...robots].sort((a, b) => {
    const onlineA = a.networkStatus === ROBOT_NETWORK_STATUSES.ONLINE
    const onlineB = b.networkStatus === ROBOT_NETWORK_STATUSES.ONLINE
    if (onlineA !== onlineB) {
      return onlineA ? -1 : 1
    }

    if (!onlineA && !onlineB) {
      return a.serialNumber.localeCompare(b.serialNumber)
    }

    const diagA = a.systemDiagnostics?.level ?? 0
    const diagB = b.systemDiagnostics?.level ?? 0
    if (diagA !== diagB) {
      return diagB - diagA
    }

    if (a.emergencyButton !== b.emergencyButton) {
      return a.emergencyButton ? -1 : 1
    }

    const activeA = hasActiveTaskRuntimeState(a)
    const activeB = hasActiveTaskRuntimeState(b)
    if (activeA !== activeB) {
      return activeA ? -1 : 1
    }

    return a.serialNumber.localeCompare(b.serialNumber)
  })
}
